import { render } from "./PrenatalVaccinesTab.vue?vue&type=template&id=234e47a4"
import script from "./PrenatalVaccinesTab.vue?vue&type=script&lang=js"
export * from "./PrenatalVaccinesTab.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__